module.exports = __webpack_public_path__ + "img/class2.1f89e779.png";